import { EmptyState } from '@fluentsms/agentnet-web-components';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ReactNode } from 'react';
import AgentNetButton from 'ui-kit/components/button/AgentNetButton';

export interface VerificationEmptyStateProps {
  icon: ReactNode;
  headerText: string;
  descriptionText: string;
  // When false the admin message replaces the action button, since the product cannot be ordered yet.
  isProductEnabled?: boolean;
  actionLabel: string;
  onAction: () => void;
  isActionDisabled?: boolean;
  actionTestId?: string;
  adminMessage?: ReactNode;
  containerTestId?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 'auto',
    },
    actionButton: {
      height: '30px',
    },
    adminText: {
      color: theme.palette.text.secondary,
    },
  }),
);

const VerificationEmptyState = ({
  icon,
  headerText,
  descriptionText,
  isProductEnabled,
  actionLabel,
  onAction,
  isActionDisabled,
  actionTestId,
  adminMessage,
  containerTestId,
}: VerificationEmptyStateProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.emptyState} data-testid={containerTestId}>
      <EmptyState
        icon={icon}
        className={classes.emptyState}
        headerText={headerText}
        descriptionText={descriptionText}
      />
      <Box mt={1}>
        {isProductEnabled ? (
          <AgentNetButton
            onClick={onAction}
            color="primary"
            variant="contained"
            size="small"
            className={classes.actionButton}
            plusIcon
            data-testid={actionTestId}
            disabled={isActionDisabled}
          >
            {actionLabel}
          </AgentNetButton>
        ) : (
          <Typography variant="body1" className={classes.adminText}>
            {adminMessage}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default VerificationEmptyState;
